import { APP_INITIALIZER, Provider } from '@angular/core';

import { CommonApiService } from 'src/app/shared/services/common-api.service';
import { TokenManagerService } from 'src/app/core/services/token-manager.service';
import { AppToken } from 'src/app/shared/constants/app.constant';

function appConfigFactory(
  commonApiService: CommonApiService,
  tokenManagerService: TokenManagerService
): () => Promise<any> {
  return () => {
    const element = document.getElementsByTagName('body');
    const storeId = new URLSearchParams(window.location.search).get('id');
    element[0]?.classList?.remove('loaded');
    return commonApiService.getAppConfiguration(storeId)
      .toPromise().then(response => {
        tokenManagerService.appConfiguration = response;
        localStorage.setItem(AppToken.UserToken, tokenManagerService.appConfiguration.Token);
        element[0]?.classList?.add('loaded');
      });
  };
}

export function provideAppConfig(): Provider {
  return {
    provide: APP_INITIALIZER,
    useFactory: appConfigFactory,
    multi: true,
    deps: [CommonApiService, TokenManagerService]
  };
}
